module.exports = __webpack_public_path__ + "static/media/track.9fb13a3f.svg";